/**
 * 自定义： 自动翻滚， 暂时项目中没有使用
 */
const vars = {};

function doBind(el, binding) {
  const isDisabledScroll = binding.value.disabled;
  if (isDisabledScroll) {
    return;
  }
  const duration = binding.value.duration || 3000;
  const id = binding.value.id || 0;
  if (vars[id] && vars[id].interval) {
    clearInterval(vars[id].interval);
    delete vars[id].interval;
  }

  if (vars[id] && vars[id].timer) {
    clearTimeout(vars[id].timer);
    delete vars[id].timer;
  }

  let timer = setTimeout(function () {
    let _field = el.firstElementChild;
    _field.style.marginTop = '-' + el.offsetHeight + 'px';
    clearTimeout(timer);
    if (vars[id] && vars[id].interval) {
      clearInterval(vars[id].interval);
      delete vars[id].interval;
    }

    let interval = setInterval(function () {
      let firstElementChild = el.firstElementChild;
      firstElementChild.style.marginTop = '0px';

      el.appendChild(firstElementChild);
      let upElementChild = el.firstElementChild;
      upElementChild.style.marginTop = '-' + el.offsetHeight + 'px';
    }, duration);

    if (!vars[id]) {
      vars[id] = {
        interval: interval,
      };
    } else {
      vars[id].interval = interval;
    }
  }, 3000);

  if (!vars[id]) {
    vars[id] = {
      timer: timer,
    };
  } else {
    vars[id].timer = timer;
  }
}

function marquee() {
  const mrq = {
    name: 'Marquee',
    bind(el, binding) {
      doBind(el, binding);
    },
    update(el, binding) {
      doBind(el, binding);
    },
  };

  return mrq;
}

export default marquee;
